import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { getTeam } from "./thunks/get-team";
import { listDeliveries } from "./thunks/list-deliveries";

const name = "team";

export const slice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTeam.pending, (state) => {
        state.isPending = true;
        state.isRejected = false;
      })
      .addCase(getTeam.fulfilled, (state, action) => {
        state.roster = action.payload;
        state.isPending = false;
      })
      .addCase(getTeam.rejected, (state) => {
        state.isPending = false;
        state.isRejected = true;
      })
      .addCase(listDeliveries.pending, (state) => {
        state.isDeliveriesPending = true;
        state.isDeliveriesRejected = false;
      })
      .addCase(listDeliveries.fulfilled, (state, action) => {
        state.deliveries = action.payload;
        state.isDeliveriesPending = false;
      })
      .addCase(listDeliveries.rejected, (state) => {
        state.isDeliveriesPending = false;
        state.isDeliveriesRejected = true;
      });
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
